<template>
	<Layout :pageTitle="'Ingresar'" class="">
		<div class="container">
			<div class="row row-xs  mt-5 pb-5">
				<div class="col-12  mt-4 mb-5 justify-content-center bg-white">
					<div class="form-box">
						<Login :redirectTo="redirectTo" />
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from "@/components/Layout"
import Login from "./Login"

export default {
	name: "loginPage",
	components: {
		Layout,
		Login
	},
	data() {
		return {
			redirectTo: this.$route.query.redirectTo || null
		}
	},
	beforeMount() {
		console.log("mount login")
	}
}
</script>

<style scoped>
.form-box {
	margin: auto;
	flex-grow: 1;
	padding: 2rem 2rem;
	max-width: 400px;
}
h3 {
	font-size: 1.3rem;
	font-weight: 600;
}

@media (min-width: 1200px) {
	.login-bg {
		background-size: auto;
		background-position: right;
		background-repeat: no-repeat;
	}
}
</style>
